'use strict';
var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/freezing.js
// module id = 325
// module chunks = 0